import styled from 'styled-components';

import { colors, fontSizes } from '../../theme';
import InputButtonPrimitive from '../Input/primitives/InputButtonPrimitive';

interface LabelProps {
  $isChecked?: boolean;
  $isDisabled?: boolean;
}

export const Label = styled.label<LabelProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: 24px;
  margin: 4px;
  padding-right: 12px;
  font-size: ${fontSizes.xs};
  text-transform: none;
  background: ${({ $isChecked }) => ($isChecked ? colors.white : colors.sand)};
  border: ${({ $isChecked }) =>
    `1px solid ${$isChecked ? colors.white : colors.sand}`};
  border-radius: 12px;
  box-shadow: ${({ $isChecked }) =>
    $isChecked ? `2px 2px 10px ${colors.sand}` : 'none'};

  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  user-select: none;

  &:hover {
    border-color: ${colors.concrete};
  }
`;

interface CircleProps {
  $isChecked?: boolean;
  $color?: string;
}

export const Circle = styled.span<CircleProps>`
  width: 12px;
  height: 12px;
  margin: 0 8px;
  background: ${({ $isChecked, $color }) =>
    $isChecked ? $color : colors.concrete};
  border-radius: 50%;
`;

export const Focus = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 12px;
`;

export const InputElement = styled(InputButtonPrimitive)`
  margin: 0;
  appearance: none;

  &:focus-visible + ${Focus} {
    outline: 4px solid ${colors.concrete};
  }
`;
